import { swSettings } from "app/common/services/swSettings";
import { keywordGroupsQueryClient } from "app/services/keyword-groups";
import type { IKeywordsGroupService } from "app/services/keywordsGroup/keywordsGroupTypes";

const isKeywordsGroupNameUsed = async (keywordsGroupName: string, queryClient?: any): Promise<boolean> => {
    if (!queryClient) {
        return false;
    }

    try {
        const userGroups = await keywordGroupsQueryClient.getUserGroups();
        return userGroups.some(({ Name }) => Name === keywordsGroupName);
    } catch {
        return false;
    }
};

const generateGroupNameFromKeywordInner = async (
    keyword: string,
    index: number,
    queryClient?: any,
): Promise<string> => {
    const keywordsGroupName = `${keyword} (${index})`;
    if (!(await isKeywordsGroupNameUsed(keywordsGroupName, queryClient))) {
        return keywordsGroupName;
    }
    return generateGroupNameFromKeywordInner(keyword, index + 1, queryClient);
};

const generateGroupNameFromKeyword = async (keyword: string, queryClient?: any): Promise<string> => {
    if (!(await isKeywordsGroupNameUsed(keyword, queryClient))) {
        return keyword;
    }
    return generateGroupNameFromKeywordInner(keyword, 1, queryClient);
};

const canShareKeywordsGroup = (): boolean => swSettings.components.Home.resources.HasKeywordsGroupShare;

export const keywordsGroupService: IKeywordsGroupService = {
    generateGroupNameFromKeyword,
    canShareKeywordsGroup,
};
